import { useEffect, useRef } from "react";
import QRCode from "qrcode";

interface QRLabelProps {
  value: string;
  title: string;
  subtitle?: string;
  footer?: string;
  size?: number;
}

export function QRLabel({ value, title, subtitle, footer, size = 120 }: QRLabelProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current && value) {
      QRCode.toCanvas(canvasRef.current, value, { width: size, margin: 1 }, (err) => {
        if (err) console.error("QR generation error:", err);
      });
    }
  }, [value, size]);

  return (
    <div className="border border-border rounded-lg p-3 bg-card flex items-center gap-3 print:break-inside-avoid print:border-black print:p-4">
      <canvas ref={canvasRef} width={size} height={size} className="flex-shrink-0" />
      <div className="flex-1 min-w-0 print:min-w-0">
        <p className="font-bold text-foreground text-sm leading-tight whitespace-normal break-words print:text-base">{title}</p>
        {subtitle && <p className="text-xs text-muted-foreground whitespace-normal break-words mt-0.5 print:text-sm">{subtitle}</p>}
        {footer && <p className="text-xs text-muted-foreground whitespace-normal break-words mt-1 font-mono print:text-sm">{footer}</p>}
      </div>
    </div>
  );
}
